import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Token } from '../../model/Model';
import { SummaryBlock } from './SummaryBlock';
import { useCheckinState } from '../../state/state';

export const VisitorHeader = () => {
    const history = useHistory();
    const { token } = useParams<Token>();

    const { activeCheckin } = useCheckinState();

    const [clickable, setClickable] = useState(false);

    const onLogoClick = useCallback(() => {
        if (clickable) {
            history.replace(`/welcome/${token}`);
        }
    }, [token, clickable]);

    useEffect(() => {
        if (history) {
            if (history.location.pathname !== `/welcome/${token}`) {
                setClickable(true);
            }
        }
    }, [history, token]);

    return (
        <SummaryBlock display className="summary-block text-center">
            <div onClick={onLogoClick} className={clickable ? 'clickable' : ''}>
                <div className="heading">
                    {activeCheckin?.profile?.name}
                </div>
                <div className="sub-heading">
                    <b>{activeCheckin?.profile?.company}</b>
                </div>
                <div className="sub-heading">
                    {activeCheckin?.profile?.phone}
                </div>
            </div>
        </SummaryBlock>
    );
}
